import { Injectable } from '@angular/core';
import { createPublicClient, fallback, http } from 'viem'
import { polygon } from 'viem/chains'
import { polygonAmoy } from '../shared/const/polygonAmoy';
import { environment } from 'src/environments/environment';
import { ChainEnvironmentConfig } from 'src/environments/environment.model';


@Injectable({
    providedIn: 'root'
  })
  
export class publicClientConfig {

    /**
     * Builds the ordered RPC url list for a chain: the primary PROVIDER first
     * (preserving existing behaviour), followed by any configured PROVIDERS
     * as fallbacks. Duplicates are removed so a url is never retried twice.
     * @param {ChainEnvironmentConfig} chainConfig environment block for the chain
     * @returns {string[]} rpc urls in priority order
     */
    private rpcUrls(chainConfig: ChainEnvironmentConfig): string[] {
        const urls: string[] = [
            chainConfig.PROVIDER,
            ...(chainConfig.PROVIDERS ?? [])
        ].filter((url): url is string => Boolean(url));
        return Array.from(new Set(urls));
    }

    /**
     * Publics client
     * @param {any} chainId
     * @returns
     */
    public publicClient(chainId:any) {
        let networkType:any = polygon;
        const chainConfig = (environment as any)[environment.SUPPORTED_CHAINS[0]] as ChainEnvironmentConfig;
        const RPC_URLS = this.rpcUrls(chainConfig);
        if(chainId == '0x13882' || Number(chainId) === polygonAmoy.id){
            networkType = polygonAmoy;
        }
        return createPublicClient({
            chain: networkType,
            transport: fallback(
                RPC_URLS.map((url: string) => http(url, { retryCount: 2 })),
                { rank: false }
            )
        })
    }

}